import script from "./RegistrosSniesPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegistrosSniesPanel.vue?vue&type=script&setup=true&lang=ts"

import "./RegistrosSniesPanel.vue?vue&type=style&index=0&id=2a50f768&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a50f768"]])

export default __exports__